import Reveal from "@/components/Reveal";

const ingredients = [
  {
    id: "lavender",
    name: "لافندر",
    latin: "Lavandula",
    benefit: "مهدّئ طبيعي يساعد على تنقية الجلد حول الظفر.",
    img: "/ing-lavender.webp",
  },
  {
    id: "eucalyptus",
    name: "أوكالبتوس",
    latin: "Eucalyptus",
    benefit: "منعش ومطهّر، يدعم الشعور بالنظافة والانتعاش.",
    img: "/ing-eucalyptus.webp",
  },
  {
    id: "tea-tree",
    name: "شجرة الشاي",
    latin: "Melaleuca",
    benefit: "من أشهر الزيوت الطبيعية في العناية بالأظافر المعرّضة للفطريات.",
    img: "/ing-teatree.webp",
  },
  {
    id: "thyme",
    name: "زعتر",
    latin: "Thymus",
    benefit: "غنيّ بالثيمول، مكوّن عشبي معروف بخصائصه المنقّية.",
    img: "/ing-thyme.webp",
  },
];

export default function Ingredients() {
  return (
    <section id="ingredients" className="border-y border-[#2E9E6B]/10 bg-[#E8F5EF]/50 py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <p className="text-sm font-bold tracking-[0.3em] text-[#2E9E6B]">من الصيدلية الخضراء</p>
          <h2 className="font-display mt-3 max-w-xl text-2xl font-black leading-snug text-[#0F1E19] sm:text-3xl lg:text-4xl">
            أربع نباتات… وتركيبة واحدة تصنع الفرق
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {ingredients.map((ing, i) => (
            <Reveal key={ing.id} delay={i * 0.08}>
              <div
                className="group overflow-hidden rounded-3xl border border-[#2E9E6B]/15 bg-white transition-all duration-500 hover:-translate-y-2 hover:border-[#2E9E6B]/40 hover:shadow-xl hover:shadow-emerald-900/10"
                data-testid={`ingredient-card-${ing.id}`}
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={ing.img}
                    alt={ing.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <span className="absolute bottom-3 right-3 rounded-full bg-[#0F1E19]/80 px-3 py-1 text-[10px] font-bold tracking-widest text-[#D4AF37] backdrop-blur-sm">
                    {ing.latin}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-display text-lg font-black text-[#0F1E19]">{ing.name}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-[#566B63]">{ing.benefit}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
